module.exports = __webpack_public_path__ + "static/media/LoadingGif.1af68cbe.gif";